import { useState } from 'react';

/**
 * Client-side search and paging over a content pool that is already in memory
 * (the CMS feeds are fetched whole at startup). Changing the query returns to
 * page one; `matches` is what the page shows and `pages` what the controls need.
 */
export function usePagedList<T>(
    items: T[],
    perPage: number,
    query: string,
    haystack: (item: T) => string,
): { page: number; setPage: (page: number) => void; pages: number; matches: T[]; pageItems: T[] } {
    const [page, setPageState] = useState(1);
    const [lastQuery, setLastQuery] = useState(query);
    if (query !== lastQuery) {
        setLastQuery(query);
        setPageState(1);
    }

    const q = query.trim().toLowerCase();
    const matches = q ? items.filter((item) => haystack(item).toLowerCase().includes(q)) : items;
    const pages = Math.max(1, Math.ceil(matches.length / perPage));
    const current = Math.min(page, pages);
    const pageItems = matches.slice((current - 1) * perPage, current * perPage);

    return { page: current, setPage: setPageState, pages, matches, pageItems };
}
